export default "__VITE_ASSET__I3D3oEag__"